import style from "./TableRow.module.scss";
import { IHistoryRecord } from "@interfaces/user/historyRecord";

export function TableRow({
    data
}: {
    data: IHistoryRecord
}) {
    return (
        <div className={style.row}>
            <div className={style.cell}>
                <p className="w-full truncate">$ {data.amount}</p>
            </div>
            <div className={style.cell}>
                {formatDate(data.change_date || "")}
            </div>
            <div className={style.cell}>
                {
                    data.description === "promo-code"
                        ? "Промокод"
                        : null
                }
                {
                    data.description === "monobank"
                        ? "monobank"
                        : null
                }
                {
                    data.description === "crypto"
                        ? "USDT"
                        : null
                }
            </div>
            <div className={style.cell}>
                <p className="w-full truncate">{data.promo_code}</p>
            </div>
        </div>
    )
}

function formatDate(date: string) {
    const [year, month, day] = date.split("T")[0].split("-")

    return day + "." + month + "." + year;
}